import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { tentatives } from '../components/dashboard/organisms/TentativeBuilder/store/TentativeStore.js';
import { dynamicForm } from './DynamicFormStore.js';

export default {
    modules: {
        tentatives: tentatives,
        dynamicForm: dynamicForm,
    },
    state: {
        selectedLanguage: null,
        page: {
            title: null,
            vpv: null,
        },
        vendor: null,
        version: 'v1',
        rateGroup: null,
        eventTypes: null,
        eventType: null,
        instantBooking: {
            searchCanInstantBook: false,
            orderValidForInstantBooking: false,
        },
        packages: [],
        package: null,
        priceCalendar: {
            prices: null,
            pricesVat: null,
            bestPriceDates: null,
            alreadyFetched: {},
            scrolledPast: [],
        },
        availabilityCalendarSpaces: {
            dates: null,
            alreadyFetched: {},
            specificDateSearch: null,
        },
        availabilityCalendarRooms: {
            dates: null,
            alreadyFetched: {},
            specificDateSearch: null,
        },
        classes: null,
        themes: null,
        loading: {
            priceCalendar: false,
            packages: false,
        },
        settings: {
            showPricesWithVat: false,
            hideVatToggle: false,
            showPriceCalendar: true,
            showInstantBooking: true,
            showAvailabilityInCalendar: true,
        },
        search: {
            startTime: null,
            endTime: null,
            participants: null,
            accommodation: null,
            agreementCode: null,
            complete: false,
        },
        order: {
            vendor: null,
            startTime: null,
            endTime: null,
            participants: null,
            days: null,
            mounted: false,
            package: null,
            sections: [],
        },
    },
    getters,
    actions,
    mutations,
};
